import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import MadeByBadge from "@/components/brand/MadeByBadge";

/** Public privacy page — accessible without login. */
export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-[#F9F8F6] text-[#0A0A0A]" data-testid="privacy-page">
      <header className="sticky top-0 z-10 bg-white border-b-[3px] border-[#0A0A0A] px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center gap-3">
          <Link
            to="/login"
            className="w-9 h-9 border-hard-2 rounded-xl bg-white flex items-center justify-center press-btn shadow-hard-sm"
            data-testid="privacy-back-btn"
            aria-label="Geri"
          >
            <ArrowLeft strokeWidth={3} className="w-4 h-4" />
          </Link>
          <div>
            <div className="text-[10px] uppercase font-black tracking-widest text-[#555]">Yasal</div>
            <div className="font-display text-2xl leading-tight">Gizlilik Politikası</div>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto p-4 md:p-8">
        <article className="prose-yappo space-y-4 text-sm md:text-base leading-relaxed">
          <p className="text-xs text-[#555] font-bold">Son güncelleme: 7 Şubat 2026</p>

          <h2 className="font-display text-xl">1. Hangi Verileri Topluyoruz?</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li><b>Hesap bilgileri:</b> ad-soyad, e-posta, profil fotoğrafı, kısa biyografi</li>
            <li><b>İçerik:</b> gönderdiğiniz mesajlar, medya, reels ve reaksiyonlar</li>
            <li><b>Sosyal ilişkiler:</b> arkadaşlıklar, sohbet katılımları, görev serileri</li>
            <li><b>Konum (opsiyonel):</b> sadece {"\u201C"}Konum paylaşımı{"\u201D"} aktifken yaklaşık konum</li>
            <li><b>Teknik veri:</b> cihaz/tarayıcı bilgisi, IP adresi (güvenlik amacıyla)</li>
            <li><b>Push abonelikleri:</b> yalnızca {"\u201C"}Uygulama kapalıyken bildirim{"\u201D"} açıksa</li>
          </ul>

          <h2 className="font-display text-xl">2. Bu Verileri Nasıl Kullanıyoruz?</h2>
          <p>
            Verilerinizi yalnızca hizmeti sağlamak, güvenliği korumak, kötüye kullanımı
            tespit etmek ve yasal yükümlülükleri yerine getirmek için işleriz.
            <b> Hiçbir zaman üçüncü taraflara satılmaz.</b>
          </p>

          <h2 className="font-display text-xl">3. Mesajlar ve Şifreleme</h2>
          <p>
            Mesajlar cihazınızdan sunucuya <b>HTTPS/WSS ile şifreli</b> iletilir ve
            veritabanında saklanır. Yappo teknik ekibi arıza gidermek için gerektiğinde
            içeriğe erişebilir; ancak <b>rutin okuma yapılmaz</b>. Hukuki yükümlülük olmadıkça
            içeriğiniz üçüncü taraflarla paylaşılmaz.
          </p>

          <h2 className="font-display text-xl">4. Ne Kadar Süre Saklıyoruz?</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Mesajlar ve medya: hesabınız aktif olduğu sürece</li>
            <li>Fısıltı (whisper) mesajları: en fazla 60 saniye</li>
            <li>Anonim oda mesajları: oda kapanınca silinir</li>
            <li>Hesap silme talebi: 30 gün içinde tüm veriler kalıcı olarak silinir</li>
          </ul>

          <h2 className="font-display text-xl">5. Çerezler ve Yerel Depolama</h2>
          <p>
            Oturum açık tutmak için <code>access_token</code> (JWT) ve/veya
            <code>session_token</code> HttpOnly çerezleri kullanılır. Ayarlarınız ve
            bildirim tercihleri gibi tercih verileri tarayıcı yerel depolamasında tutulur.
            Yappo, üçüncü taraf reklam çerezi kullanmaz.
          </p>

          <h2 className="font-display text-xl">6. Google ile Giriş</h2>
          <p>
            Google ile giriş yaptığınızda; ad, e-posta ve profil resminizi alırız.
            Ek izin talep etmeyiz. Erişimi Google Hesabı ayarlarınızdan istediğiniz an
            iptal edebilirsiniz.
          </p>

          <h2 className="font-display text-xl">7. Haklarınız (KVKK / GDPR)</h2>
          <p>Şu haklara sahipsiniz:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Verilerinize erişme ve düzeltme talep etme</li>
            <li>Hesabınızı silme / verilerinizin kalıcı silinmesini talep etme</li>
            <li>Konum paylaşımı gibi opsiyonel işlemeleri istediğiniz an durdurma</li>
            <li>Şikâyetiniz için ilgili veri koruma otoritesine başvurma</li>
          </ul>
          <p>Talep için: <a href="mailto:destek@yappo.chat" className="underline font-bold">destek@yappo.chat</a></p>

          <h2 className="font-display text-xl">8. Çocukların Gizliliği</h2>
          <p>
            Yappo 13 yaşından küçük kullanıcıları hedeflemez. 13 yaş altında olduğu
            tespit edilen hesaplar silinir. Ebeveynler, çocuklarına ait bir hesabın
            silinmesini talep edebilir.
          </p>

          <h2 className="font-display text-xl">9. Değişiklikler</h2>
          <p>
            Bu politikanın güncellenmiş versiyonu her zaman burada yayımlanır. Önemli
            değişiklikler uygulama içi bildirim veya e-posta ile bildirilir.
          </p>

          <p className="text-xs text-[#555] mt-6">
            Ayrıca bkz. <Link to="/terms" className="underline font-bold">Kullanıcı Sözleşmesi</Link>.
          </p>
        </article>
        <div className="mt-8 flex justify-center pb-4">
          <MadeByBadge />
        </div>
      </main>
    </div>
  );
}
